<template>
  <div class="p-list-representation-record-modal-content w-100 row">
    <form id="signup-form" class="row w-100" v-on:submit.prevent="submit">
      <div class="row w-100">
            <div :class="{ 'p-list-representation-error': $v.formData.title.$error }" class="d-flex align-items-center mb-4 align-items-center p-edit-representation-form-item" >
              <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
                نام مجموعه
              </label>
              <input v-model="formData.title" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
            </div>

            <div :class="{ 'p-list-representation-error': $v.formData.mobile.$error }"  class="d-flex align-items-center mb-4 align-items-center p-edit-representation-form-item" >
              <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
                موبایل کاربر سالندار
              </label>
              <input v-model="formData.mobile" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
            </div>

            <div  :class="{ 'p-list-representation-error': $v.formData.name.$error }" class="d-flex align-items-center mb-4 align-items-center p-edit-representation-form-item" >
              <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
                نام سالن
              </label>
              <input v-model="formData.name" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
            </div>

      </div>

      <div class="flex-column justify-content-center w-100 p-list-salon-owner-export-btns d-flex flex-lg-row ">
        <button  type="submit" class="p-list-representation-btn btn btn-primary btn-sm mb-lg-0 mb-3">
          جستجو
        </button>
    </div>
    </form>
  </div>

</template>

<script>
import { required, minLength, between, numeric } from 'vuelidate/lib/validators'

export default {
  props: {
    originalFormData: { type: [Array, Object], default: () => [] }
  },
  //   data () {
  //     return {
  //       formData: {
  //         title: null,
  //         mobile: null,
  //         name: null
  //       }
  //     }
  //   },

  data () {
    return {
      formData: {}
    }
  },
  validations: {
    formData: {
      title: {
      },
      mobile: {
        currentFunc (value) {
          if (value !== '') {
            return /^09[0-9]{9}$/.test(value)
          }
          return true
        }
      },
      name: {
      }
    }

  },
  methods: {
    submit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$message.error('لطفا اطلاعات خود را بررسی کنید')
      } else {
        this.$emit('searchData', this.formData)
      }
    }
  }
}
</script>
